export default "__VITE_ASSET__1abd4c8d__"